import axios from 'axios';

let instance;

const getClientExternal = () => {
  return (instance = instance || axios.create({ withCredentials: true }));
};

export default getClientExternal;
